<script>
  import Vue from 'vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import DadosSolicitacao from './compartilhado/FormDadosSolicitacao.vue';
  import VueSweetAlert from 'vue-sweetalert';
  import solicitacaoCancelamentoContratoServico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';

  Vue.use(VueSweetAlert);

  export default {
    components: { DadosSolicitacao, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        solicitacao: {
          idContrato: this.$route.params.idContrato,
          idProjeto: this.$route.params.idProjeto
        },
        carregando: false,
        arquivos: []
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Cancelamento Contrato - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoMostrar = false;
    },
    created() {
      if (this.$route.params.id) {
        this.carregar(this.$route.params.id);
      }
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosSolicitacao
          .validarDadosSolicitacao()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-solicitacao"]').tab('show');
            }

            return valido;
          })
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-cancelamento-contrato.relatorio', id, 'solicitacao-cancelamento-contrato');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        return solicitacaoCancelamentoContratoServico.adicionarAlterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoCancelamentoContratoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => solicitacaoCancelamentoContratoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.carregando = false;
          });
      },
      download(arquivo) {
        solicitacaoCancelamentoContratoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
    },
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="row">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-solicitacao">
                  Dados da solicitação
                </a>
              </li>

              <li v-if="configuracao.usarArquivosSolicitacaoCancelamentoContrato">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>

              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoCancelamentoContrato">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="tab-dados-solicitacao" class="tab-pane active">
                <div class="panel-body">
                  <dados-solicitacao ref="dadosSolicitacao"
                                     :solicitacao.sync="solicitacao"
                                     :edicao="!!$route.params.id">
                  </dados-solicitacao>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default" :to="{ name: 'solicitacao-cancelamento-contrato' }" active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>
            <button
                id="salvar"
                type="button"
                class="btn btn-primary"
                @click="salvar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-cancelamento-contrato/componentes/SolicitacaoCancelamentoContratoForm.vue